import React, { useState, useEffect, Fragment } from "react";
import { Button, Modal, Space, Form, Input, Switch, message, Select } from "antd";
import { SearchList } from "../config-center-v3";
import HOC from "../util/HOC";
import lib from "../util/lib";
import axios from "axios";

const FormItem = Form.Item;
const { Option } = Select;
@HOC.mapAuthButtonsToState({
    pagePath: "/tempory-user",
})
export default class extends SearchList {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.editRef = React.createRef();
        this.state.roleList = [];
        this.state.buttons = [];
    }

    isContainCode(code) {
        return this.state.buttons.includes(code);
    }

    componentDidMount() {
        lib.request({
            url: "/ucenter-customer/role/list",
            data: {
                systemCode: lib.config.systemCode,
            },
            success: res => {
                this.setState({
                    roleList: res,
                });
            },
        });
    }

    load(_, toTop) {
        let { pagination, search, config } = this.state;
        var data = {
            level: 1, // 展示临时用户
            systemCode: lib.config.systemCode,
        };
        this.setState({ _loading: true });
        Object.assign(data, pagination, search);
        lib.request({
            url: config.page.api,
            data: data,
            success: data => {
                this.setState({
                    pagination: data.page,
                    dataList: data.dataList || [],
                    _loading: false,
                });
                toTop && (document.querySelector(".table-panel .ant-table-body").scrollTop = 0);
                setTimeout(this.resetSize, 100);
            },
            fail: () => {
                this.setState({
                    _loading: false,
                });
            },
        });
    }

    getConfig() {
        return axios.get("https://maria.yang800.com/api/data/v2/250").then(res => {
            const config = res.data.data;
            // 为角色搜索条件的API添加systemCode参数
            if (config.searchKeyList) {
                config.searchKeyList.forEach(item => {
                    if (item.api === "/ucenter-customer/role/list") {
                        item.api = `/ucenter-customer/role/list?systemCode=${lib.config.systemCode}`;
                    }
                });
            }
            return config;
        });
    }

    renderStatus(row) {
        return (
            <Switch
                checked={row.statusName === "启用"}
                onChange={e => {
                    lib.request({
                        url: "/ucenter-customer/tempUser/enable",
                        data: {
                            userId: row.userId,
                            status: e ? 1 : 0,
                        },
                        needMask: true,
                        success: res => {
                            message.success(`${e ? "启" : "禁"}用成功`);
                            this.load();
                        },
                    });
                }}
            />
        );
    }

    editHandle = row => {
        this.setState(
            {
                editModal: true,
                editRow: row,
            },
            () => {
                row.roleIds = row.roleIds || [];
                this.editRef.current.setFieldsValue(row);
            },
        );
    };

    resetHandle = row => {
        // 判断用户是否关联多个企业
        if (row?.masterCount >= 2) {
            // 关联多个企业的情况，显示提示信息，不允许重置
            let modal = Modal.info({
                title: "重置密码",
                content: "该用户已关联多个企业，不可重置密码，请用户自行修改；如忘记密码请联系技术处理",
                onOk: () => modal.destroy(),
                okText: "我知道了",
            });
        } else {
            // 正常重置密码流程
            let modal = Modal.confirm({
                title: "重置密码",
                content: "重置后，密码将恢复到初始密码Abc123，用户可在界面自行修改密码",
                onOk: () => {
                    lib.request({
                        url: "/ucenter-customer/tempUser/resetPwd",
                        data: {
                            userId: row.userId,
                        },
                        needMask: true,
                        success: res => {
                            message.success("重置密码成功");
                            this.load();
                            modal.destroy();
                        },
                    });
                },
                onCancel: () => modal.destroy(),
                okText: "确定",
                cancelText: "取消",
            });
        }
    };

    deleteHandle = row => {
        let modal = Modal.confirm({
            title: "删除",
            content: "是否确认解除当前临时工与当前企业之间的关系？删除后该临时工登录后则不再有操作此企业的权限。",
            onOk: () => {
                lib.request({
                    url: "/ucenter-customer/tempUser/remove",
                    data: {
                        userId: row.userId,
                    },
                    needMask: true,
                    success: res => {
                        message.success("删除员工成功");
                        this.load();
                        modal.destroy();
                    },
                });
            },
            onCancel: () => modal.destroy(),
            okText: "确定",
            cancelText: "取消",
        });
    };

    myOperation(row) {
        return (
            <Space>
                <span className="link" onClick={() => this.editHandle(row)}>
                    编辑
                </span>
                <span className="link" onClick={() => this.resetHandle(row)}>
                    重置密码
                </span>
                <span className="link" onClick={() => this.deleteHandle(row)}>
                    删除
                </span>
            </Space>
        );
    }

    isSameStatus(list, handle) {
        return list.every(item => item.status == list[0].status);
    }

    batchHandle = handle => {
        let { selectedRows } = this.state;
        console.log(selectedRows);
        if (!selectedRows.length) {
            message.warning("请选择数据");
        } else if (!this.isSameStatus(selectedRows, handle)) {
            message.warning("请选择同类型的数据");
        } else {
            this[handle](selectedRows);
        }
    };

    disableHandle = selectedRows => {
        lib.request({
            url: "/ucenter-customer/tempUser/batchDisable",
            data: {
                userId: selectedRows.reduce((prev, curr) => [...prev, curr.userId], []),
            },
            needMask: true,
            success: res => {
                message.success("批量禁用成功");
                this.load();
            },
        });
    };

    enableHandle = selectedRows => {
        lib.request({
            url: "/ucenter-customer/tempUser/batchEnable",
            data: {
                userId: selectedRows.reduce((prev, curr) => [...prev, curr.userId], []),
            },
            needMask: true,
            success: res => {
                message.success("批量启用成功");
                this.load();
            },
        });
    };

    changeHandle = () => {
        this.setState({
            batchChangeModal: true,
        });
    };

    batchChangeCancel = () => {
        this.setState({
            batchChangeModal: false,
        });
    };

    batchChangeOk = () => {
        let { selectedRows } = this.state;
        this.formRef.current.validateFields().then(values => {
            lib.request({
                url: "/ucenter-customer/tempUser/batchUpdateRole",
                data: {
                    systemCode: lib.config.systemCode,
                    userIdList: selectedRows.reduce((prev, curr) => [...prev, curr.userId], []),
                    roleIdList: values.roleIdList,
                },
                needMask: true,
                success: res => {
                    message.success("批量更换角色成功");
                    this.load();
                    this.setState({
                        batchChangeModal: false,
                    });
                },
            });
        });
    };

    editOk = () => {
        let { editRow } = this.state;
        this.editRef.current.validateFields().then(values => {
            lib.request({
                url: "/ucenter-customer/tempUser/update",
                data: {
                    userId: editRow.userId,
                    ...values,
                },
                success: res => {
                    message.success("编辑成功");
                    this.load();
                    this.setState({
                        editModal: false,
                        editRow: {},
                    });
                },
            });
        });
    };

    editCancel = () => {
        this.setState({
            editModal: false,
            editRow: {},
        });
    };

    renderModal() {
        let { batchChangeModal, roleList, selectedRows, editRow, editModal } = this.state;
        const formLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
        };
        return (
            <React.Fragment>
                {/* 编辑弹窗 */}
                <Modal
                    open={editModal}
                    title="编辑临时角色"
                    onOk={this.editOk}
                    onCancel={this.editCancel}
                    destroyOnClose
                    forceRender
                    okText="确定"
                    cancelText="取消">
                    <Form ref={this.editRef} preserve={false} {...formLayout}>
                        <FormItem
                            label="用户名"
                            name="userName"
                            rules={[
                                { required: true, message: "请输入用户名" },
                                {
                                    validator(rules, value) {
                                        if (value?.length < 3) {
                                            return Promise.reject(new Error("最少请输入3位用户名"));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}>
                            <Input disabled maxLength={50} />
                        </FormItem>
                        <FormItem label="角色" name="roleIds" rules={[{ required: true, message: "请选择角色" }]}>
                            <Select showSearch optionFilterProp="children" mode="multiple">
                                {roleList.map(item => (
                                    <Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </FormItem>
                        <FormItem label="姓名" name="nickName">
                            <Input maxLength={128} />
                        </FormItem>
                        {/* <FormItem label="手机号" name="mobile">
              <Input />
            </FormItem> */}
                        {/* <FormItem label="当前状态" name="status" valuePropName="checked">
            <Switch checkedChildren="已启用" unCheckedChildren="已禁用" />
          </FormItem> */}
                    </Form>
                </Modal>
                {/* 更换角色弹窗 */}
                <Modal
                    title="批量更换角色"
                    open={batchChangeModal}
                    onOk={this.batchChangeOk}
                    onCancel={this.batchChangeCancel}
                    okText="确定"
                    cancelText="取消"
                    destroyOnClose>
                    <Form ref={this.formRef} preserve={false} {...formLayout}>
                        <span>已选中{selectedRows.length}位用户</span>
                        <FormItem
                            label="角色(可多选)"
                            name="roleIdList"
                            rules={[{ required: true, message: "请选择角色" }]}>
                            <Select showSearch optionFilterProp="children" mode="multiple">
                                {roleList.map(item => (
                                    <Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </FormItem>
                    </Form>
                </Modal>
            </React.Fragment>
        );
    }

    renderLeftOperation() {
        return (
            <Space>
                <Button onClick={() => this.batchHandle("disableHandle")}>批量禁用</Button>
                <Button onClick={() => this.batchHandle("enableHandle")}>批量启用</Button>
                <Button onClick={() => this.batchHandle("changeHandle")}>批量更换角色</Button>
            </Space>
        );
    }

    renderRightOperation() {
        return (
            <Space>
                <Button onClick={() => lib.openPage("/tempory-user-log?page_title=操作日志")}>操作日志</Button>
                {this.isContainCode("importOldTemporyUser") && (
                    <Button
                        onClick={() =>
                            lib.openPage(
                                `/import-data?page_title=已有${lib.getParam(
                                    "page_title",
                                )}导入&code=${encodeURIComponent("UCENTER_CUSTOMER.IMPORT_EXIST_USERSUB")}&systemCode=${
                                    lib.config.systemCode
                                }`,
                            )
                        }>
                        导入已有临时员工
                    </Button>
                )}
                {this.isContainCode("importNewTemporyUser") && (
                    <Button
                        onClick={() =>
                            lib.openPage(
                                `/import-data?page_title=新${lib.getParam("page_title")}导入&code=${encodeURIComponent(
                                    "UCENTER_CUSTOMER.IMPORT_USERSUB",
                                )}&systemCode=${lib.config.systemCode}`,
                            )
                        }>
                        导入新临时员工
                    </Button>
                )}
                <Button
                    className="btn"
                    onClick={() => {
                        let { pagination, search } = this.state;
                        lib.request({
                            url: "/park-gate/export/createTask",
                            needMask: true,
                            data: {
                                params: {
                                    ...pagination,
                                    ...search,
                                },
                                systemCode: lib.config.systemCode,
                                code: "UCENTER_CUSTOMER.EXPORT_USERSUB",
                            },
                            success: json => {
                                lib.openPage("/download-center?page_title=下载中心");
                            },
                        });
                    }}>
                    导出 &#xe638;
                </Button>
            </Space>
        );
    }
}
